import Card from "@pathwright/ui/src/components/card/Card"
import type { Card as CardState } from "@pathwright/ui/src/components/card/types"

import { Box } from "@chakra-ui/react"
import { InvitationContext } from "@pathwright/graphql-client/src/generated"
import { default as WebInvitations } from "@pathwright/features/src/modules/invitation/Invitations"
import InvitationHeader from "./InvitationHeader"

const Invitations = ({
  card,
  context
}: {
  card: CardState
  context: InvitationContext | null
}) => {
  return (
    <Card card={{ ...card }} navless>
      <InvitationHeader card={card} context={context} />
      <Box p={4}>
        <WebInvitations context={context} />
      </Box>
    </Card>
  )
}

Invitations.displayName = "Invitations"

export default Invitations
